module.exports = {"UM_DOMAIN":"heymath.co.za/um","REV_DOMAIN":"heymath.co.za/rev","PC_DOMAIN":"heymath.co.za/pc","WEB_DOMAIN":"heymath.co.za","OPS_DOMAIN":"ops.heymath.com","LUMOS_PC_DOMAIN":"pc.heymath.com","LUMOS_UM_DOMAIN":"heymath.co.za/lum","WIRIS_DOMAIN":"me.heymath.com","CS_DOMAIN":"cs.heymath.co.za","ORIG_CS_DOMAIN":"cs.heymath.com","CP_DOMAIN":"contests.heymath.com","CONTEST_UM_DOMAIN":"contests.heymath.com/um","CP_DOMAIN_API":"contests.heymath.com/api"}


//////////////////
// WEBPACK FOOTER
// ./src/config/urls.json
// module id = 588
// module chunks = 0